import { SmoothLink as Link } from "@/components/navigation";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export interface CategoryItem {
  slug: string;
  name: string;
  icon?: ReactNode;
}

interface CategoryFilterProps {
  categories: CategoryItem[];
  activeCategory?: string;
  basePath: string;
  allPath?: string; // Separate path for "All" button
  allLabel?: string;
  className?: string;
}

export function CategoryFilter({
  categories,
  activeCategory,
  basePath,
  allPath,
  allLabel = "All",
  className,
}: CategoryFilterProps) {
  // Use allPath if provided, otherwise derive from basePath (remove last segment)
  const allLinkPath = allPath ?? basePath;
  
  return (
    <div className={cn("flex flex-wrap justify-center gap-3 mb-12", className)}>
      <Link to={allLinkPath.endsWith('/') ? allLinkPath : `${allLinkPath}/`}>
        <Button
          variant={!activeCategory ? "default" : "outline"}
          className={cn(
            "rounded-full",
            !activeCategory ? "" : "hover:text-primary"
          )}
        >
          {allLabel}
        </Button>
      </Link>
      {categories.map((cat) => (
        <Link key={cat.slug} to={`${basePath}/${cat.slug}/`}>
          <Button
            variant={activeCategory === cat.slug ? "default" : "outline"}
            className={cn(
              "rounded-full gap-2",
              activeCategory === cat.slug ? "" : "hover:text-primary"
            )}
          >
            {cat.icon}
            {cat.name}
          </Button>
        </Link>
      ))}
    </div>
  );
}
